import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'redux/rootReducer'
/**
 * Direct selector to the parcelle state domain
 */

const selectParcelleDomain = (state: AppState) => state.parcelle

/**
 * Other specific selectors
 */

export const makeSelectParcelles = createSelector(
  selectParcelleDomain,
  (substate) => substate.parcelles
)

export const makeSelectParcelleJson = createSelector(
  selectParcelleDomain,
  (substate) => substate.parcelleJson
)

export const makeSelectStatusParcelle = createSelector(
  selectParcelleDomain,
  (substate) => substate.statusParcelle
)

export const makeSelectErrorParcelle = createSelector(
  selectParcelleDomain,
  (substate) => substate.errorParcelle
)

export const makeSelectSelectedParcelleIndex = createSelector(
  selectParcelleDomain,
  (substate) => substate.selectedParcelleIndex
)

export const makeSelectSelectedParcelleMoreInformationIndex = createSelector(
  selectParcelleDomain,
  (substate) => substate.selectedParcelleMoreInformationIndex
)

export const makeSelectSelectedParcelleMoreInformation = createSelector(
  selectParcelleDomain,
  (substate) => {
    if (!substate.selectedParcelleMoreInformationIndex) return null
    return substate.parcelles[substate.selectedParcelleMoreInformationIndex]
  }
)

/**
 * Default selector
 */

const selectParcelle = createSelector(
  selectParcelleDomain,
  (substate) => substate
)

export default selectParcelle
